// Показателите на „По артикули".
//
// „Средно на артикул" е оборот / ПРОДАДЕНИ БРОЙКИ, тоест средната цена на
// една продадена бройка — не оборот / уникални артикули. Двете се разминават
// в пъти и подтекстът казва коя от тях е.

import { useTranslation } from "react-i18next";

import { fmtEuro } from "../../../../utils/currency";
import { formatNumber } from "../../../../components/dataTable";
import { ReportKpiCard } from "../ReportKpiCard";
import { deltaPercent } from "../reportDelta";

type PeriodTotals = { quantity: number; revenue: number };

type Props = {
  uniqueItems: number;
  quantity: number;
  revenue: number;
  /** Предходният равен отрязък; `null` = сравнението е изключено. */
  previous: PeriodTotals | null;
  isNarrow: boolean;
};

export const ItemsKpis = ({
  uniqueItems,
  quantity,
  revenue,
  previous,
  isNarrow,
}: Props) => {
  const { t } = useTranslation();

  const averagePerUnit = quantity > 0 ? revenue / quantity : 0;

  return (
    // Класовете са ЦЕЛИ литерали — Tailwind сканира изходния текст и не вижда
    // име, сглобено с template literal.
    <div
      className={`grid gap-2.5 ${
        isNarrow ? "grid-cols-2" : "grid-cols-2 lg:grid-cols-4"
      }`}
    >
      <ReportKpiCard
        kicker={t("reportsPage.itemsUniqueKicker")}
        value={String(uniqueItems)}
        sub={t("reportsPage.itemsUniqueSub")}
      />

      {/* Без подтекст: kicker-ът вече казва всичко, а редът долу остава за Δ. */}
      <ReportKpiCard
        kicker={t("reportsPage.itemsSoldKicker")}
        value={formatNumber(quantity)}
        delta={
          previous ? deltaPercent(quantity, previous.quantity) : undefined
        }
      />

      <ReportKpiCard
        kicker={t("reportsPage.itemsRevenueKicker")}
        value={fmtEuro(revenue)}
        sub={t("reportsPage.itemsRevenueSub")}
        delta={previous ? deltaPercent(revenue, previous.revenue) : undefined}
        hero
      />

      <ReportKpiCard
        kicker={t("reportsPage.itemsAvgKicker")}
        value={fmtEuro(averagePerUnit)}
        sub={t("reportsPage.itemsAvgSub")}
      />
    </div>
  );
};
